import { CAvatar, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import { CButton, CFormTextarea } from '@coreui/react'

import React, { useEffect, useMemo, useRef, useState } from 'react'
import PENoteView from '../../components/shared/PENoteView'
import { useIndexedDB } from '../../context/IndexedContext'
import Diagnosis from './Diagnosis'

const PEHierarchyComponents = ({ viewData, splitTitle = false, isNormalOrModal = false, onDataUpdate, MasterDiagnosisData, patientDBData, noteCallType, setPatientDBData, patientID, setUpdatePatientDiagnosis, setUpdateOfflineStructure, noteStructureRef }) => {
  const [hierarchy, setHierarchy] = useState([{ ...viewData }])
  const [alertIds, setAlertIds] = useState([])
  const [educationFiles, setEducationFiles] = useState([])
  const [diagnosisData, setDiagnosisData] = useState([])
  // const noteStructureRef = useRef()

  const tremorID = 356915
  const diagnosisId = 72

  const { getOfflineData, getOpenChartOfflineData, getProviderDetails, saveOpenChartOfflineData, saveOfflineData, getPreSignedData } = useIndexedDB()

  const handleInputChange = (id, value) => {
    const updateInputData = (items) => {
      return items.map((item) => {
        if (item.id === id) {
          return { ...item, inputData: value }
        }
        if (item.hierarchy?.length > 0) {
          return { ...item, hierarchy: updateInputData(item.hierarchy) }
        }
        return item
      })
    }

    const updated = updateInputData(hierarchy)
    setHierarchy(updated)

    if (onDataUpdate) {
      onDataUpdate(updated[0]) // only the root item needs to be sent back
    }
  }

  //  const toggleIsSelected = (id, items) => {
  //    return items.map((item) => {
  //      if (item.id === id) {
  //        return { ...item, isSelected: !item.isSelected }
  //      }

  //      if (item.hierarchy?.length) {
  //        let updatedHierarchy = toggleIsSelected(id, item.hierarchy)

  //        const clickedChild = updatedHierarchy.find((child) => child.id === id)

  //        if (clickedChild && item.hierarchyType === 'single' && !['header', 'subHeader'].includes(clickedChild.type)) {
  //          updatedHierarchy = updatedHierarchy.map((child) => ({
  //            ...child,
  //            isSelected: child.id === id,
  //          }))
  //        }

  //        return {
  //          ...item,
  //          hierarchy: updatedHierarchy,
  //        }
  //      }

  //      return item
  //    })
  //  }

  const handleAddDiagnosis = async (diagnosis, currentNoteRefData) => {
    try {
      const data = noteCallType === 'OpenChart' ? ((await getOpenChartOfflineData()) ? noteCallType === '/provider/pre-signed' : await getPreSignedData()) : await getOfflineData()
      const loggedUser = await getProviderDetails()
      const loggedUserID = loggedUser?.ID
      const userData = { ...(data[loggedUserID] || {}) }
      const patientData = { ...(userData[patientID] || {}) }
      const existingPatient = patientData?.patientData || {}
      const existingDiagnosisObject = patientData?.diagnosisDataModifyMap || []
      const existingCurrentNote = patientData?.currentNote || {}
      const existingDiagnosisString = existingPatient?.Diagnosis || ''
      const existingFinalDiagnosis = patientData?.finalDiagnosis || ''

      const existingCurrentNoteData = existingCurrentNote?.data || {}

      const existingArray = existingDiagnosisString
        .split(',')
        .map((d) => d.trim())
        .filter(Boolean)

      if (!existingArray.includes(diagnosis)) {
        existingArray.push(diagnosis)
      }

      const updatedDiagnosisString = existingArray.join(',')

      let updateDiagnosisData = {}

      if (existingDiagnosisObject.length > 0) {
        const existing = existingDiagnosisObject[0]
        updateDiagnosisData = {
          ...existing,
          Diagnosis: updatedDiagnosisString,
        }
      } else {
        updateDiagnosisData = {
          Diagnosis: updatedDiagnosisString,
        }
      }

      const updatedInnerPatient = {
        ...existingPatient,
        Diagnosis: updatedDiagnosisString,
      }

      const updatedCurrentNote = {
        ...existingCurrentNote,
        data: currentNoteRefData,
      }

      const updatedPatientData = {
        ...patientData,
        patientData: updatedInnerPatient,
        diagnosisDataModifyMap: [updateDiagnosisData],
        currentNote: updatedCurrentNote,
        finalDiagnosis: updatedDiagnosisString,
      }

      const updatedUserData = {
        ...userData,
        [patientID]: updatedPatientData,
      }

      const updatedData = {
        ...data,
        [loggedUserID]: updatedUserData,
      }

      noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(updatedData) : await saveOfflineData(updatedData)
      //  setPatientDBData(updatedPatientData)
      setUpdatePatientDiagnosis(updatedPatientData)
      //  setUpdateOfflineStructure(updatedData)
    } catch (error) {
      console.log('error', error)
    }
  }

  const addDiagnosisIdsToNote = async (id) => {
    try {
      const diagnosis = MasterDiagnosisData.find((d) => d.id === id)

      if (diagnosis) {
        const key = diagnosis.Name.trim()
        const existingData = noteStructureRef.current?.information?.[key] || []
        if (!existingData.includes('Added from Physical Examination')) {
          noteStructureRef.current.information = {
            ...noteStructureRef.current.information,
            [key]: [...existingData, 'Added from Physical Examination'],
          }
        }
      }

      const existingIds = noteStructureRef.current?.metadata?.diagnosisIds || []
      const tempIds = noteStructureRef.current?.metadata?.tempIds || []

      // const newTempIds = ids.filter((id) => !existingIds.includes(id))

      const combinedIds = [...existingIds, id]
      const combinedTempIds = [...tempIds, id]

      const uniqueIds = Array.from(new Set(combinedIds))
      const uniqueTempIds = Array.from(new Set(combinedTempIds))

      noteStructureRef.current = {
        ...noteStructureRef.current,
        metadata: {
          ...noteStructureRef.current.metadata,
          diagnosisIds: uniqueIds,
          tempIds: uniqueTempIds,
        },
      }

      const addInPatientData = await handleAddDiagnosis(diagnosis.Name.trim(), noteStructureRef?.current)
      // await handleAddDiagnosisOfflineIdsToNote(uniqueIds, uniqueTempIds)
    } catch (error) {
      console.log('error while diagnosis add', error)
    }
    // await saveTreatsShell(false)
  }

  const addDiagnosisToPatient = async () => {
    const noteData = patientDBData?.currentNote?.data
    // noteStructureRef.current = noteData
    await addDiagnosisIdsToNote(diagnosisId)
  }

  const toggleIsSelected = (id, items) => {
    return items.map((item) => {
      if (item.id === id) {
        if (id == tremorID && !item.isSelected) {
          addDiagnosisToPatient()
        }
        return { ...item, isSelected: !item.isSelected }
      }

      if (item.hierarchy?.length) {
        let updatedHierarchy = toggleIsSelected(id, item.hierarchy)

        const clickedChild = updatedHierarchy.find((child) => child.id === id)
        if (!clickedChild) {
          return { ...item, hierarchy: updatedHierarchy }
        }

        const isSelecting = clickedChild.isSelected

        if (isSelecting && item.hierarchyType === 'single' && !['header', 'subHeader'].includes(clickedChild.type)) {
          updatedHierarchy = updatedHierarchy.map((child) => ({
            ...child,
            isSelected: child.id === id,
          }))
        }

        const anySelected = updatedHierarchy.some((child) => child.isSelected)

        return {
          ...item,
          isSelected: anySelected,
          hierarchy: updatedHierarchy,
        }
      }

      return item
    })
  }

  // if u want to preserve header

  // const toggleIsSelected = (id, items) => {
  //   return items.map((item) => {
  //     const isHeaderType = ['header', 'subHeader'].includes(item.type)

  //     // Toggle the clicked item
  //     if (item.id === id) {
  //       return { ...item, isSelected: !item.isSelected }
  //     }

  //     // Process children
  //     if (item.hierarchy?.length) {
  //       let updatedHierarchy = toggleIsSelected(id, item.hierarchy)

  //       const clickedChild = updatedHierarchy.find((child) => child.id === id)

  //       // If nothing inside was clicked → just update hierarchy
  //       if (!clickedChild) {
  //         return {
  //           ...item,
  //           hierarchy: updatedHierarchy,
  //         }
  //       }

  //       const isSelecting = clickedChild.isSelected

  //       // Single select logic (only when child clicked, not header)
  //       if (isSelecting && item.hierarchyType === 'single' && !isHeaderType && !['header', 'subHeader'].includes(clickedChild.type)) {
  //         updatedHierarchy = updatedHierarchy.map((child) => ({
  //           ...child,
  //           isSelected: child.id === id,
  //         }))
  //       }

  //       // Auto-select or auto-unselect header/subheader
  //       if (!isHeaderType) {
  //         const anySelected = updatedHierarchy.some((child) => child.isSelected)

  //         return {
  //           ...item,
  //           isSelected: anySelected, // this is your required rule
  //           hierarchy: updatedHierarchy,
  //         }
  //       }

  //       // For header click → do NOT auto change selection
  //       return {
  //         ...item,
  //         hierarchy: updatedHierarchy,
  //       }
  //     }

  //     return item
  //   })
  // }

  const handleToggle = (id) => {
    const updated = toggleIsSelected(id, hierarchy)

    setHierarchy(updated)
    if (onDataUpdate) {
      onDataUpdate(updated[0])
    }
  }

  const handleAlertToggle = (id) => {
    setAlertIds((prev) => (prev.includes(id) ? prev.filter((alertId) => alertId !== id) : [...prev, id]))
  }

  const renderHierarchy = (items = [], rowAlign = false) => (
    <>
      <div className={`timelines-container ${rowAlign ? 'd-flex align-items-start flex-wrap' : ''}`}>
        <div className="timelines-line"></div>
        {items.map((item) => (
          <div key={item.id} className="timelines-item my-1" style={{ marginLeft: '20px' }}>
            <div className="d-flex align-items-center gap-2">
              <CButton
                className="my-1"
                size="sm"
                color={item.isSelected ? 'success' : 'secondary'}
                onClick={(e) => {
                  handleToggle(item.id)
                }}
                style={{
                  borderRadius: '10px',
                  alignSelf: 'flex-start',
                  cursor: 'pointer',
                  backgroundColor: item.type === 'title' ? 'transparent' : (item.isSelected && item.type === 'header') || (item.isSelected && item.type === 'subHeader') ? '#414a59' : item.isSelected && item.type === 'option' ? 'green' : 'transparent',
                  outline: 'none',
                  color: item.type === 'title' ? '#fff' : item.isSelected ? '#fff' : 'white',
                  border: (item.isSelected && item.type && item.type === 'header') || (item.isSelected && item.type && item.type === 'subHeader') ? '0px solid #414a59' : item.isSelected && item.type === 'option' ? '0px solid green' : '1px solid #989898',
                  // color: (item.isSelected && item.type && item.type === 'header') || (item.isSelected && item.type && item.type === 'subHeader') ? 'white' : item.isSelected && item.type === 'option' ? 'white' : 'black',
                  // color: 'white',
                }}
              >
                {item.name.split('-')[0] || ''}
              </CButton>

              {/* Education Files Button */}
              {item?.education?.length > 0 && (
                <div className="d-flex align-items-start  gap-1">
                  <CButton
                    onClick={() => {
                      if (item.education.length === 0 || !item.education) return
                      setEducationFiles(item.education)
                    }}
                    className="rounded-pill p-0 d-flex align-items-center justify-content-center "
                    style={{ width: '20px', height: '20px', fontSize: '10px' }}
                    color="secondary"
                    variant="outline"
                  >
                    e
                  </CButton>
                </div>
              )}

              {/* Alert Toggle Button */}
              {item?.alert !== '' && (
                <CButton onClick={() => handleAlertToggle(item.id)} className="rounded-pill p-0 d-flex align-items-center justify-content-center" style={{ width: '20px', height: '20px', fontSize: '12px' }} color="secondary" variant="outline">
                  i
                </CButton>
              )}
              {alertIds.includes(item.id) && (
                <p className="p-0 text-warning m-0" style={{ fontSize: '10px' }}>
                  {item.alert}
                </p>
              )}
            </div>

            {/* Input Field for Selected Hierarchy */}
            {item.isSelected && item.hierarchyType === 'input' && (
              <CFormTextarea
                rows={3}
                type="text"
                value={item.inputData || ''}
                onChange={(e) => handleInputChange(item.id, e.target.value)}
                placeholder="Enter value"
                className="form-control mt-2"
                style={{ background: 'transparent', border: '1px solid #989898', color: 'white', width: '300px', minHeight: '50px', overflow: 'auto' }}
              />
            )}

            {/* Render Child Hierarchy */}
            {item.isSelected && item.hierarchy?.length > 0 && renderHierarchy(item.hierarchy, item.rowAlign)}
          </div>
        ))}
      </div>

      <CModal alignment="center" scrollable backdrop="static" visible={educationFiles.length > 0} onClose={() => setEducationFiles([])}>
        <CModalHeader style={{ background: '#282828', color: 'white' }}>
          <CModalTitle style={{ color: 'white' }}>Education Files</CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            overflowY: 'auto',
            color: 'white',

            backgroundColor: '#282828',
          }}
        >
          <div className="d-flex flex-wrap gap-2">
            {educationFiles.map((edu, idx) => (
              <div
                key={idx}
                style={{
                  width: '100px',
                  height: '100px',

                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {edu.type === 'image' && <img className="w-100 h-100 object-fit-cover" src={edu.url} alt="Education File" onError={(e) => (e.target.src = 'fallback-image-url')} />}
                {edu.type === 'video' && <video className="w-100 h-100 object-fit-cover" controls src={edu.url} />}
                {edu.type === 'pdf' && (
                  <a href={edu.url} target="_blank" rel="noopener noreferrer" className="text-white text-center" style={{ fontSize: '12px' }}>
                    View PDF
                  </a>
                )}
                {edu.type === 'file' && (
                  <a href={edu.url} download className="text-white text-center" style={{ fontSize: '12px' }}>
                    Download File
                  </a>
                )}
              </div>
            ))}
          </div>
        </CModalBody>
        <CModalFooter
          style={{
            backgroundColor: '#282828', // dark gray

            color: 'white',

            padding: '8px 20px',
          }}
        >
          <CButton color="secondary" onClick={() => setEducationFiles([])}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className=" ">
          <div style={{ width: '4000px', overflow: 'auto' }}>{isNormalOrModal ? <div className=" ">{renderHierarchy(hierarchy[0]?.hierarchy)}</div> : <div className=" ">{renderHierarchy(hierarchy[0]?.hierarchy)}</div>}</div>
        </div>

        {/* <div style={{ width: "40%", height: "70vh" }}>
                    <PENoteView data={hierarchy} />
                </div> */}
      </div>
    </>
  )
}

export default PEHierarchyComponents
